import { takeLatest } from 'redux-saga/effects'
import { getFirebase } from 'react-redux-firebase'

import { types as userActionTypes } from '../user/user.reducer'

// firebase - login with email and password
export const processManualLogout = () => {
    const firebase = getFirebase()
    return firebase.auth().signOut()
}

// watch logout
export function* watchManualLogout() {
    yield takeLatest(userActionTypes.LOGOUT, processManualLogout)
}
